import {useEffect} from 'react';

const loadScript = (id: string, content: string) => {
  if (document.getElementById(id)) return null; // Возвращаем null, если существует

  const script = document.createElement('script');
  script.id = id;
  script.async = true;
  script.type = 'text/javascript';
  script.textContent = content; // Безопаснее innerHTML
  document.head.appendChild(script); // В head для early load

  return script;
};

const addNoScriptFallback = (counterId: number) => {
  if (document.getElementById('yandex-metrika-noscript')) return;

  const noscriptDiv = document.createElement('div');
  noscriptDiv.id = 'yandex-metrika-noscript';
  noscriptDiv.innerHTML = `
    <noscript>
      <div>
        <img src="https://mc.yandex.ru/watch/${counterId}" style="position:absolute; left:-9999px;" alt="" />
      </div>
    </noscript>
  `;
  document.body.appendChild(noscriptDiv);

  return noscriptDiv;
};

export const ThirdPartyScripts = () => {
  useEffect(() => {
    // Roistat (как раньше, без изменений)
    const roistatScript = loadScript('roistat-script', `
      (function(w, d, s, h, id) {
        w.roistatProjectId = id;
        w.roistatHost = h;
        var p = "https://";
        var u = /^.*roistat_visit=[^;]+(.*)?$/.test(d.cookie) ? "/dist/module.js" : "/api/site/1.0/" + id + "/init?referrer=" + encodeURIComponent(d.location.href);
        var js = d.createElement(s);
        js.charset = "UTF-8";
        js.async = 1;
        js.src = p + h + u;
        var js2 = d.getElementsByTagName(s)[0];
        js2.parentNode.insertBefore(js, js2);
      })(window, document, 'script', 'cloud.roistat.com', '1b42fcb7fbfefe6af9b8b2c690cdce1b');
    `);

    // Marquiz (как раньше)
    const marquizScript = loadScript('marquiz-script', `
      (function(w, d, s, o){
        var j = d.createElement(s); j.async = true; j.src = '//script.marquiz.ru/v2.js'; j.onload = function() {
          if (document.readyState !== 'loading') Marquiz.init(o);
          else document.addEventListener("DOMContentLoaded", function() {
            Marquiz.init(o);
          });
        };
        d.head.insertBefore(j, d.head.firstElementChild);
      })(window, document, 'script', {
        host: '//quiz.marquiz.ru',
        region: 'ru',
        id: '687015074f51b500197dba38',
        autoOpen: 8,
        autoOpenFreq: 'always',
        openOnExit: false,
        disableOnMobile: false
      });
    `);

    // Yandex Metrika с вашим ID
    const yandexMetrikaScript = loadScript('yandex-metrika-script', `
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(103288230, "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
      });
    `);

    // Добавляем noscript fallback
    const noscriptElement = addNoScriptFallback(103288230);

    // Cleanup при unmount
    return () => {
      [roistatScript, marquizScript, yandexMetrikaScript].forEach(script => {
        if (script && script.parentNode) script.parentNode.removeChild(script);
      });
      if (noscriptElement && noscriptElement.parentNode) noscriptElement.parentNode.removeChild(noscriptElement);
    };
  }, []);

  return null;
};